import React from 'react';
import { NavLink } from 'react-router-dom';

const Header: React.FC = () => (
    <header>
        <div className="header">
            <h1>Appointment ROI Calculator</h1>
            <nav>
                <ul>
                    <li>
                        <NavLink exact to="/" activeClassName="active">
                            Home
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/calculator" activeClassName="active">
                            Calculator
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/results" activeClassName="active">
                            Results
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/settings" activeClassName="active">
                            Settings
                        </NavLink>
                    </li>
                </ul>
            </nav>
        </div>
    </header>
);

export default Header;
